<template>
	<div class="login">
		<header>
			<template v-if="brandData?.favicon">
				<el-image
					style="max-width: 40px; vertical-align: middle"
					:src="brandData.favicon"
					fit="cover"
				/>
			</template>
			<template v-else>{{ spliceText(brandData?.brand_name) }}</template>
			<span>{{ brandData.brand_name }}</span>
		</header>
		<main>
			<div class="logo">
				<div>
					<el-image :src="brandData.url3" fit="cover" />
				</div>
				<div class="account">
					<template v-if="logo_type === 'login'">
						<h2>{{ $t('login.login') }}</h2>
						<Account @change="changeType" />
					</template>
					<ForgetPassword v-else @change="changeType" />
				</div>
			</div>
		</main>
		<footer>
			<span>{{ brandData.slogan }} {{ brandData.copyright }}</span>
			<span
				><RouterLink target="_blank" to="/terms">{{ $t('login.terms_service') }}</RouterLink></span
			>
		</footer>
	</div>
</template>

<script lang="ts" setup>
import { PropType, ref, watchEffect, provide } from 'vue'
import Account from '../Account.vue'
import ForgetPassword from '../ForgetPassword.vue'
import type { BrandDate } from '@/api/types/common'
import type { LogoType } from './AccountLogin.vue'

const props = defineProps({
	data: {
		type: Object as PropType<BrandDate>,
		default: () => {
			return {}
		},
	},
})
//获取品牌数据
const brandData = ref(props.data)
watchEffect(() => {
	brandData.value = props.data
})
const spliceText = (item) => {
	if (item) {
		return item.slice(0, 1)
	}
}
const logo_type = ref<LogoType>('login')

const changeType = (val) => {
	logo_type.value = val
}
provide('logoType', logo_type)
</script>

<style scoped lang="scss">
.login {
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	header,
	footer {
		display: flex;
		align-items: center;
		width: 100%;
		padding: 0 30px;
		background-color: #fff;
	}

	main {
		flex: 1;
		background: url('../../static/img/hw_bg.png') no-repeat;
		background-size: cover;

		.logo {
			display: flex;
			width: 880px;
			max-height: 500px;
			margin: 0 auto;
			margin-top: 80px;
			overflow: hidden;
			border-radius: 4px;

			> div {
				flex: 1;
			}

			.account {
				flex: 0 0 464px;
				padding: 60px 40px;
				background-color: #fff;

				h2 {
					font-size: 24px;
					color: #252b3a;
					text-align: center;
				}
			}
		}
	}

	header {
		height: 45px;
		box-shadow: 0 2px 8px 1px rgba(174, 186, 208, 0.27);
	}

	footer {
		justify-content: space-between;
		height: 58px;
		color: #333;

		a {
			color: #333;
		}
	}
}
</style>
